/**
 * 'Open or scroll to' component
 * Wraps a button and triggers 'open' on a modal-dialog, or 'theme.scrollToRevealElement'.
 * Falls back to the published Size Chart page if the target is unavailable.
 */
if (!customElements.get('open-or-scroll-to')) {
  class OpenOrScrollTo extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');
      if (!button) return;

      button.addEventListener('click', this.handleClick.bind(this));

      const target = document.getElementById(this.dataset.targetId);
      if (target && target.matches('modal-dialog')) {
        button.setAttribute('aria-haspopup', 'dialog');
      }
    }

    handleClick(evt) {
      const target = document.getElementById(this.dataset.targetId);
      const button = evt.currentTarget;

      if (!target) {
        window.location.assign('/pages/size-chart');
        return;
      }

      if (target.matches('modal-dialog')) {
        target.open(button);
      } else if (window.theme && typeof theme.scrollToRevealElement === 'function') {
        theme.scrollToRevealElement(target);
      } else {
        window.location.assign('/pages/size-chart');
      }
    }
  }

  customElements.define('open-or-scroll-to', OpenOrScrollTo);
}
